module.exports = __webpack_public_path__ + "img/customers-dd-l1.1efb8997.svg";